import React from 'react'

class AssignedModuleList extends React.Component {
  render() {
    return (
      <div className="table-responsive">
        <table className="table table-sm table-stripped">
          <thead className="thead-dark">
            <tr>
              <th scope="col">Prefijo</th>
              <th scope="col">Número de serie</th>
              <th scope="col">Tipo</th>
            </tr>
          </thead>
          <tbody>
            {this.props.Modules.map(module => (
              <tr>
                <th scope="row">{module.serialPrefix}</th>
                <th scope="row">{module.serialNumber}</th>
                <td scope="row">{module.tipo}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }
}

export default AssignedModuleList
